<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
  >
    <v-card flat style="border-radius: 15px" class="pa-4">
      <v-card-title>
      </v-card-title>
      <v-card-text class="text-center black--text my-2" style="font-size: 11pt">
        <v-img
          contain
          lazy-src="https://cdn.siap.id/s3/masook/asset%20img/SIM/danger.png"
          max-height="250"
          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/danger.png"
        ></v-img>
        <div class="font-weight-bold headline my-3">Perhatian!</div>
        <template>
        <div v-if="data.last_month_periode">Saat ini terdeteksi ada <b>{{data.jumlah_absen}} Pegawai</b> yang statusnya masih <b>Tanpa Keterangan,</b> segera hubungi pegawai yang bersangkutan untuk melakukan klaim presensi paling lambat <b>tanggal {{pVal(current_konfigurasi,'tanggal_batas_ubah')}} setiap bulannya!</b></div>
        <div v-else>
          Terdeteksi bahwa periode sebelum periode saat ini berjalan belum tersedia di instansi Anda. Silakan membuat periode terlebih dahulu

          <br/><br/>Terima kasih</div>
        </template>
      </v-card-text>
      <v-card-actions class="justify-center">
       <v-btn text class="mr-2" style="border-radius: 5pt" @click="dialog=false" >Tutup</v-btn>
       <v-btn v-if="data.last_month_periode" color="primary" style="border-radius: 5pt" @click="goTo('pegawai')" >Lihat Daftar Pegawai</v-btn>
       <v-btn v-else color="primary" style="border-radius: 5pt" @click="goTo('periode')" >Buat Periode</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  data() {
    return {
      dialog: false,
      data: {
        alpa: 0,
        batas_klaim: 5
      },
      defData: {
        alpa: 0,
        batas_klaim: 5
      }
    }
  },
  methods: {
    open(data) {
      this.data = data
      this.dialog = true
    },


    onClose() {
      this.dialog = false
    },

    goTo(val){
      if(val==='pegawai'){
        this.$router.push({
          name: "laporan.bulanan",
          params: {
            organisasi_id: this.organisasi_id
          }
        });
      }else{
        this.$router.push({
          name: "periode",
          params: {
            organisasi_id: this.organisasi_id
          }
        });
      }

    }

  }
}
</script>
